import React from 'react';
import { Form, Input, Row, Col, Alert } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { maibFormRules } from '../../utils/validation';

const PartnerMAIBInfo = ({ disabled = false }) => {
  return (
    <div>
      <Alert
        message="MAIB Payment Integration"
        description="Configure MAIB payment gateway credentials for this partner. These settings are optional and can be updated later."
        type="info"
        icon={<InfoCircleOutlined />}
        showIcon
        style={{ marginBottom: 24 }}
      />

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Merchant ID"
            name="maib_merchant_id"
            rules={maibFormRules.maib_merchant_id}
          >
            <Input
              placeholder="Enter MAIB Merchant ID"
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Merchant Name"
            name="maib_merchant_name"
          >
            <Input
              placeholder="Enter Merchant Name"
              disabled={disabled}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Terminal ID"
            name="maib_terminal_id"
            rules={maibFormRules.maib_terminal_id}
          >
            <Input
              placeholder="Enter MAIB Terminal ID"
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Signature Key"
            name="maib_signature_key"
            rules={maibFormRules.maib_signature_key}
          >
            <Input.Password
              placeholder="Enter Signature Key"
              disabled={disabled}
              autoComplete="new-password"
            />
          </Form.Item>
        </Col>
      </Row>

      <Alert
        message="Security Notice"
        description="Keep your MAIB credentials secure. Never share them publicly or commit them to version control."
        type="warning"
        showIcon
        style={{ marginTop: 16 }}
      />
    </div>
  );
};

export default PartnerMAIBInfo;
